import * as React from 'react';
import { rem } from 'polished';
import Link from '../Link';

type WideLinkProps = React.ComponentProps<typeof Link>;

const WideLink = (props: WideLinkProps) => <Link letterSpacing="medium" fontWeight="bold" fontSize={rem('14px')} {...props} />;

export default WideLink;
